import { render, staticRenderFns } from "./SetFxRateDialog.vue?vue&type=template&id=466aec19&"
import script from "./SetFxRateDialog.vue?vue&type=script&lang=ts&"
export * from "./SetFxRateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports